import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { useLayoutContext } from '../../contexts';
import { Breadcrumbs } from '../breadcrumbs';

export const PageHeading = () => {
  // For testing purposes matchMedia needs to exist
  if (window !== undefined) {
    window.matchMedia =
      window.matchMedia ||
      function () {
        return {
          matches: false,
          addListener: function () {},
          removeListener: function () {},
        };
      };
  }

  const isDesktop = useMediaQuery('(min-width: 768px)');
  const { pageHeading, title, subtitle, hideHeader } = useLayoutContext();

  return (
    <div data-testid="page-heading" className="page-heading-container">
      <Breadcrumbs />
      {!hideHeader && (
        <div className=" md:flex md:items-center md:justify-between">
          {pageHeading && !isDesktop && (
            <div className="flex justify-end mt-4 md:mt-0 md:ml-4">
              {pageHeading}
            </div>
          )}
          <div className="flex-1 flex flex-row min-w-0">
            <h2 className="text-xl font-bold leading-7 uppercase text-evolve-highlight sm:truncate sm:tracking-tight">
              {title}
            </h2>
            {subtitle && typeof subtitle === 'string' && (
              <span className="pl-4 text-evolve-primary text-xl font-bold leading-7 uppercase sm:truncate sm:tracking-tight">
                {subtitle}
              </span>
            )}
            {subtitle && typeof subtitle !== 'string' && (
              <span className="pl-4 text-evolve-primary">{subtitle}</span>
            )}
          </div>
          {pageHeading && isDesktop && (
            <div className="flex justify-end mt-4 md:mt-0 md:ml-4">
              {pageHeading}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
